"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayEvents = void 0;
class DisplayEvents {
    builder;
    constructor(builder) {
        this.builder = builder;
    }
    static display(builder) {
        return new DisplayEvents(builder);
    }
    addPart(part) {
        this.builder.addPart(part);
        return this;
    }
    toString() {
        return this.builder.toString();
    }
    get audience() {
        return this.builder.addPart("audience").toString();
    }
    get wildcard() {
        return this.builder.wildcard;
    }
}
exports.DisplayEvents = DisplayEvents;
